/**
 * @deprecated in FloKit
 */
export const timezoneIANAs = [
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",
] as const;

/**
 * @deprecated in FloKit
 */
export type TimezoneIANAEnum = typeof timezoneIANAs[number];

/**
 * @deprecated in FloKit
 */
export const timezoneIANAToCode: { [_ in TimezoneIANAEnum]: string } = {
  "America/New_York": "ET",
  "America/Chicago": "CT",
  "America/Denver": "MT",
  "America/Los_Angeles": "PT",
};
